import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import NotFoundPage from "../page-not-found";
import { extractLinks } from "@/lib/helper";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const ProtectedRoute = () => {
  const [sidePanel, setSidePanel] = useState<string[]>(() => {
    const sidepanel = localStorage.getItem("sidepanel");
    if (sidepanel) {
      try {
        const decodedSidepanel = JSON.parse(atob(sidepanel));
        return extractLinks(decodedSidepanel);
      } catch (error) {
        console.error("Error decoding Base64 string sidepanel:", error);
        return [];
      }
    }
    return [];
  });
  
  // Get auth state from Redux instead of localStorage directly
  const { userToken, userInfo } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  // React to changes in userInfo (which includes sidepanel data)
  useEffect(() => {
    const sidepanel = localStorage.getItem("sidepanel");
    if (sidepanel) {
      try {
        const decodedSidepanel = JSON.parse(atob(sidepanel));
        console.log({ decodedSidepanel });
        const links = extractLinks(decodedSidepanel);
        setSidePanel(links);
      } catch (error) {
        console.error("Error decoding Base64 string sidepanel:", error);
        setSidePanel([]); // Clear on error
      }
    } else {
      setSidePanel([]); // Clear when no sidepanel
    }
  }, [userInfo]); // Depend on userInfo changes instead of sidepanel string

  const isAuthenticated = Boolean(userToken);
  
  // Redirect to login if not authenticated and trying to access a protected route
  if (!isAuthenticated && location.pathname !== "/") {
    return <Navigate to="/" />;
  }

  // Redirect to dashboard if authenticated and trying to access the login page
  if (isAuthenticated && location.pathname === "/") {
    return <Navigate to={sidePanel[0]} />;
  }

  // Allow public payment gateway route to be accessed without being part of sidePanel
  const isPublicPaymentRoute = location.pathname === "/payment";
  const isPublicTraining = location.pathname.startsWith("/admin/training");

  // Check if the current path is not in the links array and redirect to the first available link
  if (isAuthenticated) {
    if (
      isPublicPaymentRoute ||
      isPublicTraining ||
      sidePanel.some((link) => {
        if (!link) return false;
        if (link === location.pathname) return true;

        const normalizedLink = link.endsWith("/") ? link.slice(0, -1) : link;
        const normalizedPath = location.pathname.endsWith("/")
          ? location.pathname.slice(0, -1)
          : location.pathname;

        if (normalizedLink === normalizedPath) return true;

        // Facility sub-modules have their own permissions; do not inherit from /admin/facility
        if (normalizedLink === "/admin/facility") {
          return false;
        }

        // Sub-routes must be separated by "/"
        return location.pathname.startsWith(`${normalizedLink}/`);
      })
    ) {
      return <Outlet />;
    } else if (sidePanel.length > 0) {
      return <NotFoundPage />;
    }
  }
  return <Outlet />;
};

export default ProtectedRoute;
